export const releaseNotesButtonLink =
  'https://www.hpe.com/info/hpe-greenlake-platform-release-notes'
